import CityPage from "../CityPage";

export default function Elmhurst() {
  return <CityPage slug="elmhurst" />;
}
